import React, { useEffect } from 'react';
import PlanCardsList from './components/PlanCardsList/PlanCardsList';
import styles from './Payment.module.scss';
import Stepper from './components/Stepper/Stepper';
import PurchaseReportButton from './components/PurchaseReportButton/PurchaseReportButton';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { useMediaQuery } from '@uidotdev/usehooks';
import { Flex, Typography, Tag } from 'antd';
import AppLoader from '../../common/components/AppLoader';
import { colors, fontSize, primitiveColors, radius, spacing } from '../../theming';
import { paymentMethods } from '../../common/constants/paymentPagePaymentMethods';
import { useVinCode } from '../../common/hooks/useVinCode';
import { usePaymentContext } from '../../context/PaymentContext';
import { generatePlans } from './helper';

const Payment = () => {
    const [searchParams] = useSearchParams();
    const vinCodeFromParams = searchParams.get('vincode');
    const { t } = useTranslation(['payment', 'profile']);
    const { decodeVinData, isLoading, vinData } = useVinCode({ t });
    const { plans } = usePaymentContext();

    const getButtonBreakpoint = useMediaQuery('(max-width: 1107px)');

    useEffect(() => {
        if (vinCodeFromParams) {
            decodeVinData(vinCodeFromParams);
        }
    }, [vinCodeFromParams]);

    if (isLoading) {
        return <AppLoader />;
    }

    const formattedPlans = generatePlans({ plans, t, styles });

    return (
        <div className={styles.pricingPage}>
            <header className={styles.header}>
                <Stepper />
                <h2>{t('payment:header.title')}</h2>
                <p style={{ marginBottom: 0 }}>{t('payment:header.sub')}</p>

                {vinData?.brand && (
                    <Flex vertical align="center" justify="center" style={{ marginTop: spacing[4] }}>
                        <Typography.Text
                            style={{ fontSize: fontSize.lg, fontWeight: '700', color: primitiveColors.text }}
                        >
                            {`${vinData.brand} ${vinData.year ? vinData.year : ''}`}
                        </Typography.Text>

                        <Tag
                            style={{
                                backgroundColor: primitiveColors.text,
                                color: colors.white,
                                paddingBlock: spacing[2],
                                paddingInline: spacing[3],
                                borderRadius: radius.md,
                                boxShadow: 'none',
                                fontSize: fontSize.sm,
                                fontWeight: '700',
                                marginTop: spacing[3],
                            }}
                        >
                            {vinData.vin}
                        </Tag>
                    </Flex>
                )}
            </header>
            <PlanCardsList plans={formattedPlans} />
            <footer className={styles.footer}>
                {formattedPlans.length !== 0 && <PurchaseReportButton />}
                <p className={styles.buttonInfo}>{t('payment:footer')}</p>
                <div className={styles.paymentIcons}>
                    {paymentMethods.map(({ icon, name }) => (
                        <img key={name} src={icon} alt={name} />
                    ))}
                </div>
            </footer>
        </div>
    );
};

export default Payment;
